import React, { useState, useEffect } from "react";
import {
  Table,
  Spinner,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { deviceAllSessionAPI } from "../services/Device";
import { useHistory } from "react-router-dom";
import TableHeader from "components/TableHeader";
const chargingCache = {
  data: null,
  timestamp: null,
};


const ChargingFrequency = () => {
  const history = useHistory();
  const [deviceData, setDeviceData] = useState([]);
  const [searchData, setSearchData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState("subjectId");
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 50;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = searchData.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );
  const totalPages = Math.ceil(searchData.length / recordsPerPage);

  const handleToggle = () => {
    setIsOpen(!isOpen); // Toggle the dropdown's open status
  };
 const refreshlist = () => {
  setLoading(true);
  document.getElementById("refreshbtn").className = "fas fa-sync fa-spin";
  chargingCache.data = null;  
  getdata();
};
  const getdata = async () => {
    setLoading(true);
    getAllDevice();
};
  const applyFilters = () => {
    if (deviceData.length === 0) return;  
    let filteredList = deviceData;
    if (searchValue) {
      filteredList = deviceData.filter((item) => {
        if (item?.data?.list !== null && filterBy === "subjectId") {
          return item?.data?.list?.subjectId
            ?.toLowerCase()
            ?.includes(searchValue.toLowerCase());
        }
      });
    }
    setSearchData(filteredList);
  };
  const handleFilterByChange = (value) => {
    setSearchValue("");
    setFilterBy(value);
  };

  // Event handler for search input change
  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };
  const identifyUsersWithInactiveStim = (deviceData) => {
    const groupedData = deviceData.reduce((groups, item) => {
      if (!item?.prcId) return groups;

      if (!groups[item.prcId]) {
        groups[item.prcId] = [];
      }

      groups[item.prcId].push(item);
      return groups;
    }, {});

    const result = Object.entries(groupedData)
      .map(([prcId, data]) => {
        if (!data || data.length === 0) return null;

        // sort by latest updatedAt
        const latestRecord = [...data].sort(
        (a, b) => b.updatedAt - a.updatedAt
        )[0];

        const record = {
          ...latestRecord,
          data: latestRecord.data / 10,
        };

        return {
          prcId,
          data: { list: record },
          groupedData,
        };
      })
      .filter(Boolean);

    return result;
  };
  useEffect(() => {
    applyFilters();
  }, [filterBy, searchValue]);

  function downloadCSV(csv, filename) {
    var csvFile;
    var downloadLink;

    //define the file type to text/csv
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  function exportTableToCSV() {
    //declare a JavaScript letiable of array type
    let csv = [];
    let rows = document.querySelectorAll("table tr");

    //merge the whole data in tabular form
    for (let i = 0; i < rows.length; i++) {
      let row = [],
        cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++) row.push(cols[j].innerText);
      csv.push(row.join(","));
    }
    //call the function to download the CSV file
    let filename = "Charging_Frequency";
    downloadCSV(csv.join("\n"), filename);
  }

const getAllDevice = async (isBackground = false) => {
  try {
    const data = await deviceAllSessionAPI(100, null, "EVENT_RING_BATT");
    if (data.success) {
      const usersWithActiveStim = identifyUsersWithInactiveStim(data?.sessions);
      chargingCache.data = usersWithActiveStim;
      setDeviceData(usersWithActiveStim);
      if (!isBackground) {
        setSearchData(usersWithActiveStim);
      }
    } else {
      setDeviceData([]);
      if (!isBackground) setSearchData([]);
    }
  } catch (error) {
    console.error("Failed loading charging data:", error);
    setDeviceData([]);
    if (!isBackground) setSearchData([]);
  } finally {
    setLoading(false);
    const btn = document.getElementById("refreshbtn");
    if (btn) btn.className = "fas fa-sync fa-stop";
  }
};

  const handleSort = (column) => {
    if (sortColumn === column) {
      // Toggle sorting order if the same column is clicked again
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };
  const timeFormatMinSec = (dateStr) => {
    if (
      typeof dateStr == "undefined" ||
      dateStr == undefined ||
      dateStr == "undefined" ||
      dateStr < 1520160669214
    ) {
      return " ";
    }
    let date = new Date(parseInt(dateStr));
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime =
      (" 0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + " " + ampm;
    let newDate = new Date(parseInt(dateStr)).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    return newDate + " (" + strTime + ")";
  };

 const deviceListRecords = () => {
  let sortedList = [...currentRecords];
  if (sortColumn) {
    sortedList.sort((a, b) => {
      if (a.data.list !== null && b.data.list !== null) {
        if (sortOrder === "asc") return a?.data?.list?.[sortColumn]?.toString().localeCompare(b?.data?.list?.[sortColumn]);
        else return b?.data?.list?.[sortColumn]?.toString().localeCompare(a?.data?.list?.[sortColumn]);
      }
      return 0;
    });
  }

  if (loading) {
    return (
      <tr>
        <td colSpan="4" style={{ textAlign: "center", padding: "60px 0" }}>
          <Spinner animation="border" style={{ width: "2.5rem", height: "2.5rem", color: "#525f7f" }} />
          <div style={{ marginTop: 12, color: "#6c757d", fontSize: 14 }}>Loading...</div>
        </td>
      </tr>
    );
  }

  if (sortedList.length === 0) {
    return (
      <tr>
        <td colSpan="4" style={{ textAlign: "center", padding: "60px 0", color: "#6c757d" }}>No Record Found!</td>
      </tr>
    );
  }

  const validRecords = sortedList.filter((user) => user?.data?.list !== null);
  if (validRecords.length === 0) {
    return (
      <tr>
        <td colSpan="4" style={{ textAlign: "center", padding: "60px 0", color: "#6c757d" }}>No Record Found!</td>
      </tr>
    );
  }

 return validRecords.map((user, index) => {
  const handleClick = (event) => {
    event.preventDefault();
    history.push({ pathname: `/device/${user?.data?.list?.deviceId}` });
  };
    return (
      <tr key={index}>
        <td style={{ textAlign: "left" }}><a href="#" onClick={handleClick}>{user.data.list.prcId || "-"}</a></td>
        <td style={{ textAlign: "left" }}>{user.data.list.subjectId || "-"}</td>
        <td style={{ textAlign: "left" }}>{user.data.list.data || "-"}</td>
        <td style={{ textAlign: "left" }}>{timeFormatMinSec(user.data.list.updatedAt) || "-"}</td>
      </tr>
    );
  });
};
 useEffect(() => {
  if (chargingCache.data) {
    setDeviceData(chargingCache.data);
    setSearchData(chargingCache.data);
    getAllDevice(true); // silent background refresh
  } else {
    getdata(); // first load with spinner
  }
}, []);

 return (
  <div style={{ display: "flex", flexDirection: "column", background: "#fff", height: "100vh", overflow: "hidden" }}>
    <TableHeader
      title="Battery Voltage Trend"
      onRefresh={refreshlist}
      onDownload={exportTableToCSV}
      totalCount={searchData.length > 0 ? searchData.length : null}
      hasMore={false}
      filterContent={
  <div style={{ display: "flex", gap: 8, alignItems: "center", maxWidth: 500 }}>
    <Dropdown isOpen={isOpen} toggle={handleToggle} style={{ flexShrink: 0 }}>
      <DropdownToggle caret>Filter By: {filterBy}</DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => handleFilterByChange("subjectId")}>SubjectId</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Input
      type="text"
      placeholder={`Enter ${filterBy}`}
      value={searchValue}
      onChange={handleSearchInputChange}
      style={{ flex: 1 }}
    />
  </div>
}
    />

    <div style={{ overflowY: "auto", background: "#fff" }}>
      <Table striped hover responsive bordered className="align-items-center table-flush" style={{ margin: 0 }}>
        <thead className="thead-light" style={{ cursor: "pointer", position: "sticky", top: 0, zIndex: 1 }}>
          <tr>
            <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("prcId")}>Ring Id</th>
            <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("subjectId")}>Subject Id</th>
            <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("data")}>Voltage Level</th>
            <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("updatedAt")}>Last Sync Date/Time</th>
          </tr>
        </thead>
        <tbody>
          {deviceListRecords()}
          {searchData.length > 50 && !loading && (
            <tr>
              <td colSpan="4" style={{ textAlign: "right", padding: "12px 16px" }}>
                <div style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                  <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}
                    style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6", background: currentPage === 1 ? "#f8f9fa" : "#fff", cursor: currentPage === 1 ? "not-allowed" : "pointer", fontWeight: 500 }}>←</button>
                 <div style={{ padding: "6px 14px", borderRadius: 6, background: "#f2f0f0", color: "#0e0d0d", fontWeight: 500, fontSize: 14 }}>
  {indexOfFirstRecord + 1}–{Math.min(indexOfLastRecord, searchData.length)} of {searchData.length}
</div>
                  <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(prev => prev + 1)}
                    style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6", background: currentPage === totalPages ? "#f8f9fa" : "#fff", cursor: currentPage === totalPages ? "not-allowed" : "pointer", fontWeight: 500 }}>→</button>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  </div>
);
};

export default ChargingFrequency;
